import { createContext } from "react";

const ActiveMembershipContext = createContext({
  activeMembership: null,
  switchActiveMembership: (organization) => null,
});

export default ActiveMembershipContext;
